<mat-card class="card-primary">

    <mat-card-content>
        <img src="https://www.cpcesfe2.org.ar/wp-content/themes/consejo/img/logo.png" alt="" class="logo">
        <h2>Muchas gracias por participar</h2>

    </mat-card-content>
</mat-card>